import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as THREE from 'three';
var FRAMERATE = 60;
var FRAME_DURATION = 1000 / FRAMERATE;

// player statut
var PLAYER_STATE = {
  // player is stopped
  STOP: 0,
  // player plays animation
  PLAY: 1,
  // player is at the end of an animation
  END: 2,
  // player is paused
  PAUSE: 3
};

// Private functions
// stop timer and re-init parameter
var resetTimer = function (player) {
  if (player.id) {
    clearInterval(player.id);
    player.id = undefined;
  }
  if (player.waitTimer) {
    clearInterval(player.waitTimer);
    player.waitTimer = undefined;
  }
  player.keyframe = 0;
};

// finish animation and re-init parameter
var finishAnimation = function (player) {
  resetTimer(player);
  if (player.isEnded()) {
    player.dispatchEvent({
      type: 'animation-ended'
    });
  }
  player.dispatchEvent({
    type: 'animation-stopped'
  });
  player.duration = 0;
};

/**
 * It can play, pause or stop Animation or AnimationExpression (See below).
 * AnimationPlayer is needed to use Animation or AnimationExpression
 * AnimationPlayer emits events :
 *       - for each animation's frame;
 *       - when Animation is stopped
 *       - when Animation is ending
 */
var AnimationPlayer = /*#__PURE__*/function (_THREE$EventDispatche) {
  _inherits(AnimationPlayer, _THREE$EventDispatche);
  var _super = _createSuper(AnimationPlayer);
  function AnimationPlayer() {
    var _this;
    _classCallCheck(this, AnimationPlayer);
    _this = _super.call(this);
    _this.id = null;
    _this.keyframe = 0;
    _this.duration = 0;
    _this.state = PLAYER_STATE.STOP;
    _this.waitTimer = null;
    _this.callback = function () {};
    return _this;
  }
  _createClass(AnimationPlayer, [{
    key: "isPlaying",
    value: function isPlaying() {
      return this.state === PLAYER_STATE.PLAY;
    }
  }, {
    key: "isStopped",
    value: function isStopped() {
      return this.state === PLAYER_STATE.STOP;
    }
  }, {
    key: "isEnded",
    value: function isEnded() {
      return this.state === PLAYER_STATE.END;
    }

    // Public functions

    /**
     * Set the Player `callback` property. This callback is executed at each animation frame.
     *
     * @param {function} callback - The callback to execute at each animation frame.
     */
  }, {
    key: "setCallback",
    value: function setCallback(callback) {
      this.callback = callback;
    }

    /**
     * Play one animation.
     * If another animation is playing, it's stopped and the new animation is played.
     *
     * @param {number} duration - The duration to play
     */
  }, {
    key: "play",
    value: function play(duration) {
      this.duration = duration;
      this.dispatchEvent({
        type: 'animation-started'
      });
      this.state = PLAYER_STATE.PLAY;
      resetTimer(this);
      this.id = setInterval(this.frame.bind(this), FRAME_DURATION);
    }

    /**
     * Play an animation after a number of frames.
     *
     * @param      {number}  duration    The duration to play
     * @param      {number}  waitingFrame    The waiting time before start animation (time in frame)
     */
  }, {
    key: "playLater",
    value: function playLater(duration, waitingFrame) {
      var timew = Math.floor(FRAME_DURATION * waitingFrame);
      window.clearInterval(this.waitTimer);
      var self = this;
      this.waitTimer = window.setTimeout(function () {
        self.play(duration);
      }, timew);
    }

    /**
     * Stop the current animation.
     *
     */
  }, {
    key: "stop",
    value: function stop() {
      this.state = PLAYER_STATE.STOP;
      finishAnimation(this);
    }

    /**
     * Executed for each frame.
     *
     * @private
     */
  }, {
    key: "frame",
    value: function frame() {
      if (this.keyframe < this.duration) {
        this.keyframe++;
        this.dispatchEvent({
          type: 'animation-frame'
        });
        this.callback();
      } else {
        this.state = PLAYER_STATE.END;
        finishAnimation(this);
      }
    }
  }]);
  return AnimationPlayer;
}(THREE.EventDispatcher);
export default AnimationPlayer;